import { AxisRange } from './widget-configuration';

export function flattenUndefinedRange(range: AxisRange | undefined) {
  if (range && range[0] == null && range[1] == null) {
    return undefined;
  }

  return range;
}
